.mapPopup {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 16px;

  .tooltipRow {
    display: flex;
    justify-content: space-between;
    padding: 10.5px 8px;
  }

  .dealerList {
    display: flex;
    flex-direction: column;

    .dealerRow {
      display: flex;
      column-gap: var(--spacing-04);
      align-items: center;
      padding: 4px 8px;
    }
  }
}
